<template>
  <div class="container">
    <div class="logos">
      <div class="nrsLogo"></div>
      <div class="rfnLogo"></div>
    </div>
    <div class="unsubscribe-body">
      <div v-if="fromOM" class="center">
        <div class="body-title center-text">This mailing list is no longer active</div>
        <div class="body-message center-text">This notification service has been retired and no
          longer sends emails, so no action is needed. To manage your current NetRoadshow email
          preferences, <a :href="emailPreferencesLink" class="hyperlink">click here</a>.</div>
      </div>
      <div v-else class="center">
        <div v-if="isUnsubscribed" class="body-icon">
          <img src="../assets/images/check_rfn.png" width="35">
        </div>
        <div class="body-title">{{bodyTitle}}</div>
        <div class="body-message"
        :class="{ 'center-text' : isUnsubscribed}">{{bodyMessage}}</div>
        <div v-if="!isUnsubscribed" class="email-container">
          <div class="email-box-contaner">
              <input class="email-textbox" type="email" disabled v-bind:value="email">
          </div>
        </div>
        <div v-if="!isUnsubscribed"  class="email-catg-container">
        <div class="email-box-contaner">

           <div>
              <input type="checkbox" id="catg_NrsProspectus" value="NetroadshowResearchFnEmail" v-model="checkedEmailCategories">
              <label class="email-label" for="catg_NrsProspectus">Yes, unsubscribe from NetRoadshow and ResearchFN emails.
              <br><div class="custom-disclaimer">Please note: You will continue to receive prospectus delivery of sponsoring broker dealers. If you would like decline consent company-wide for delivery of prospectuses, please <a :href="helpTicketLink" class="hyperlink">open a help ticket </a>with NetRoadshow Support.</div></label>
           </div>
        </div>
        </div>
        <div style=" text-align: left; ">
        <button v-if="!isUnsubscribed" class="btn-white">
          <router-link :to= "GetRoute()" class="custom-link">Not now</router-link></button>
        <button v-if="!isUnsubscribed"  @click="unsubscribe" class="btn-primary">
          Unsubscribe</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '../modules/constants';

const { Api } = constants;

export default {
  data() {
    return {
      userGuid: this.$route.params.id,
      fromOM: Boolean(this.$route.query.isOm),
      bodyTitle: 'We\'re sorry to see you go!',
      bodyMessage: 'By unsubscribing, you will no longer receive email to the following address from NetRoadshow and ResearchFN:',
      unsubscribeBtnText: 'UNSUBSCRIBE ME',
      isUnsubscribed: false,
      email: null,
      checkedEmailCategories: ['NetroadshowResearchFnEmail'],
    };
  },
  computed: {
    helpTicketLink() {
      return `${process.env.VUE_APP_NRS_URL}${constants.UrlEndings.NrsHome}contact-us/tech-support`;
    },
    // Goes through NRS login so a signed-out user still lands on MyNRS Email Preferences
    emailPreferencesLink() {
      const redirectUrl = encodeURIComponent(constants.UrlEndings.MyNrsEmailPreferences);
      return `${process.env.VUE_APP_NRS_URL}${constants.UrlEndings.NrsLogin}?redirectUrl=${redirectUrl}`;
    },
  },
  created() {
    // Legacy OM links carry an OM token, not a user guid, so no API is called for them
    if (this.fromOM) return;
    this.axios.get(Api.GetUmpUser.replace('{userGuid}', this.userGuid))
      .then((response) => {
        this.email = response.data.EmailAddress ? response.data.EmailAddress : '';
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    unsubscribe() {
      if (this.email == null || this.email == '' || this.email == undefined) {
        alert('Invalid email');
        return false;
      }
      if (this.checkedEmailCategories.length === 0) {
        alert('please select an email type to unsubscribe');
        return false;
      }
      this.axios.post(Api.Unsubscribe, {
        UserGuid: this.userGuid,
        EmailAddress: this.email,
        UnsubscribedEmailTypes: this.checkedEmailCategories,
      })
        .then((response) => {
          console.log(response);
          this.unsubscribeSucessfull();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    unsubscribeSucessfull() {
      this.isUnsubscribed = true;
      this.bodyTitle = 'Unsubscribe Successful!';
      this.bodyMessage = 'You have now been unsubscribed from our mailing list.';
    },
    GetRoute() {
      return {
        name: 'home',
      };
    },
  },
};


</script>

<style lang="less" scoped>
.container {
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
  position: relative;
}

.logos{
  width: 100%;
  position: relative;
}

.rfnLogo {
 margin-bottom: 16px;
  height: 50px;
  width: 154px;
  background-image: url('../assets/images/RFN_Logo_Blue.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  position: absolute;
  top: 0;
  right: 0;
}

.nrsLogo {
 margin-bottom: 16px;
  width: 209px;
  height: 57px;
  background-image: url('../assets/images/logo-netroadshow.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.unsubscribe-body {
  justify-content: center;
  align-items: center;
  border: 1px solid #DDDDDD;
  background-color: #FFFFFF;
  border-radius: 3px;
  box-shadow: 0 1px 0 0 rbga(0,0,0,0.07);
  text-align: center;
  padding: 30px;
}

.body-title {
  padding-bottom:35px;
  height: 27px;
  color: #39424D;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.15px;
  line-height: 27px;
  text-align: left;
}
.body-message {
  color: #39424D;
  font-family: "ProximaNova";
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.1px;
  text-align: left;
  padding-bottom: 25px;
}
.body-icon{
  padding-bottom: 30px;
  padding-top: 30px;
}
.btn-primary{
  height: 36px;
  padding: 10px;
  border-radius: 4px;
  background-color: #275298;
  box-shadow: 0 1px 0 0 rgba(0,0,0,0.07);
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  border: none;
  font-family: "ProximaNova";
  margin-left:15px;
  line-height:10px;
  vertical-align: -moz-middle-with-baseline;
}

.btn-white{
  height: 36px;
  padding:10px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 0 0 rgba(0,0,0,0.07);
  color: black;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  font-family: "ProximaNova";
  line-height:10px;
  vertical-align: -moz-middle-with-baseline;
}
.custom-link {
    text-decoration: none;
    color: black;
    cursor: pointer;
}
.custom-disclaimer{
  padding-left: 5%;
  color: #475467;
}

.email-textbox{
  width: 100%;
  padding: 12px 0px;
  background: whitesmoke;
  border: none;
  text-indent: 10px;
}
.email-container{
  text-align: left;
  padding-bottom: 10px;
}

.email-catg-container{
  text-align: left;
  padding-bottom: 35px;
   font-size: 14px;
}

.email-label{
  font-size: 13px;
}

.email-box-contaner{
  padding-top:5px;
}

.center-text{
  text-align: center;
}
.hyperlink{
text-decoration: none;
}

.email-catg-checkbox{
  width: 100%;
  padding: 12px 0px;
  background: whitesmoke;
  border: none;
  text-indent: 10px;
    font-size: 13px;
}

input[type="checkbox"]
{
    vertical-align:middle;
}

.checkBoxBackground{
  background-color: #2196f3;
}

input[type=checkbox] {
    margin-right: 5px;
    cursor: pointer;
    font-size: 14px;
    width: 17px;
    height: 17px;
    position: relative;
  }

  input[type=checkbox]:after {
    position: absolute;
    width: 10px;
    height: 17px;
    top: 0;
    content: " ";
    color: #fff;
    display: inline-block;
    visibility: visible;
    padding: 0px 3px;
    border-radius: 3px;
  }

  input[type=checkbox]:checked:after {
	  content: "✓";
    font-size: 12px;
     background-color: #2196f3;
  }
</style>
